export const SET_USERNAME = "APPINFO/DATA/SET_USERNAME";
export const SET_PAGE = "APPINFO/DATA/SET_PAGE";
export const SET_REGION = "APPINFO/DATA/SET_REGION";
export const SET_TOKEN = "APPINFO/DATA/SET_TOKEN";

export type AppInfoDataState = {
  username: string | null;
  page: { page: string; section?: string | null };
  region: string;
  token: string | null;
};

interface SetUsernameAction {
  type: typeof SET_USERNAME;
  payload: string | null;
}

interface SetPageAction {
  type: typeof SET_PAGE;
  payload: { page: string; section?: string };
}

interface SetRegionAction {
  type: typeof SET_REGION;
  payload: string;
}

interface SetTokenAction {
  type: typeof SET_TOKEN;
  payload: string | null;
}

export type AppInfoDataActionTypes =
  | SetUsernameAction
  | SetPageAction
  | SetRegionAction
  | SetTokenAction
  ;
